import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { FinancialDocument } from 'src/features/financialDocuments/utils/types';

const RESOURCE = '/financial-documents/financial-document/:documentId/';

type QueryFnType = typeof queryFn;

interface DTO {
    documentId: string;
}
const queryFn = ({ documentId }: DTO): Promise<FinancialDocument> => {
    return axios.get(formatResourcePath(RESOURCE, { documentId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetFinancialDocument, RESOURCE as FINANCIAL_DOCUMENT_RESOURCE };
